import {Component, EventEmitter, inject, Input, Output, SimpleChanges} from '@angular/core';
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {CapitalCasePipe} from "../../../../pipes/capital-case.pipe";
import {AsyncPipe} from "@angular/common";
import {DxPopupComponent} from "devextreme-angular";
import {
    AuthService, DataSources, ScreenService, PermissionType, AccessType, EmailsClient, EmailLogDto, EmailLogGridViewDto,
} from "@services";
import notify from "devextreme/ui/notify";

@Component({
    selector: 'app-email-log-popup',
    imports: [CapitalCasePipe, DxPopupComponent, AsyncPipe],
    templateUrl: './email-log-popup.component.html'
})
export class EmailLogPopupComponent {
    protected dataSources = inject(DataSources);
    protected screen = inject(ScreenService);
    protected emailsClient = inject(EmailsClient);
    protected auth = inject(AuthService);
    protected sanitizer = inject(DomSanitizer);

    @Input() request: EmailLogGridViewDto;
    @Input() visible = false;
    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() onUpdate = new EventEmitter<void>();

    formData: EmailLogDto | null = null;

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        if (changes['visible'] && changes['visible'].currentValue) {
            await this.loadData();
        }
    }

    onClose() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.formData = null;
    }

    handleSuccess() {
        this.visible = false;
        this.visibleChange.emit(this.visible);
        this.onUpdate.emit();
    }

    handleError(errors: any) {
        errors.forEach(((errMsg: any) => {
            notify({
                message: errMsg.message,
                type: "error",
                displayTime: 5000,
            }, {
                position: "bottom right",
                direction: "up-push"
            });
        }));
    }

    async loadData() {
        if (this.request) {
            this.emailsClient.getEmailLog(this.request.id).subscribe({
                next: (data) => {
                    this.formData = data;
                },
                error: (errors) => this.handleError(errors)
            });
        }
    }

    getSafeHtml(html: string | null | undefined): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html || '');
    }

    splitEmails(emails: string | null | undefined): string[] {
        if (!emails) return [];
        return emails.split(',').map(e => e.trim()).filter(e => e.length > 0);
    }

    protected readonly PermissionType = PermissionType;
    protected readonly AccessType = AccessType;
}
